export default "__VITE_ASSET__DGFkMFP2__"